"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M11.646 21.998l2.379 2.381L3.924 34.406 0 36l1.645-3.975 10.001-10.027zm12.305 4.322h.008L24 20.289 32.293 12l2.27-.023.006-.009a1.446 1.446 0 0 0 1.01-2.47L31.041 4.96 26.5.483a1.445 1.445 0 0 0-2.469 1.011h-.008L24 3.708 15.707 12l-6.025.044v.007a1.44 1.44 0 0 0-1.106 2.461l6.459 6.458 6.457 6.459a1.442 1.442 0 0 0 2.463-1.107z" })
);

